module.exports = __webpack_public_path__ + "media/entities/1007-e1cd87a9.png";